import { useState } from 'react';
import { useKonfig } from '../konfigKontekst.tsx';
import { useAuth } from './AuthProvider.tsx';

/* ------------------------------------------------------------------------------
   ENHETEN SOM ANDRE FAKTOR — DE TO JA-ENE, PÅ ETT STED.

   To uavhengige spørsmål avgjør om enheten kan tilbys, og begge må svare ja:

     1. UTRULLINGEN — `konfig.deviceFactor`, satt ved bygg. AV som standard fordi
        Supabase ikke støtter faktoren ennå: Management API-et svarer «Enabling of MFA
        with WebAuthn not currently supported» (verifisert 2026-09-21,
        `docs/drift/supabase-enhetsfaktor.md`).
     2. NETTLESEREN — `auth.stoetterEnhet()`, som er sann i en Chrome i sikker kontekst
        og usann i jsdom, i en gammel nettleser og over http.

   HVORFOR IKKE `stoetterEnhet(flagg)`: porten (`typer.ts`) beskriver LEVERANDØREN, og
   `stoetterEnhet()` er ett spørsmål om nettleseren. Å skyve et byggflagg inn i porten
   ville gjort adapteren avhengig av panelets utrulling, og v2 bytter porten ved å bytte
   én fil (K22). Flagget hører i skjermlaget.

   HVORFOR IKKE «hver skjerm kombinerer selv»: da må hver ny skjerm huske OG-en, og en
   glemt `&&` er en knapp som ikke kan virke — nøyaktig feilen flagget finnes for.
   Kombinasjonen bor derfor her, i én hook begge skjermene kaller, og en tredje skjerm
   arver den ved å kalle den samme.

   TO VERDIER, IKKE ÉN, fordi «Min innlogging» stiller to spørsmål:
     tilbys — skal enheten i det hele tatt NEVNES? Av med flagget: da finnes raden ikke.
     mulig  — kan den brukes HER? Med flagget på, men uten støtte i nettleseren, står
              raden med grunnen i stedet for en knapp (DD-08, «aldri en død knapp»).
   Tofaktorskjermen bruker bare `mulig`: foran låsen er en rad uten handling ikke en
   opplysning, den er en blindvei.
------------------------------------------------------------------------------ */

export interface Enhetsstatus {
  /** Utrullingen er på: enheten kan nevnes på skjermen. */
  tilbys: boolean;
  /** Utrullingen er på OG nettleseren kan seremonien: enheten kan faktisk brukes. */
  mulig: boolean;
}

/**
 * Leses ÉN gang per montering, som `stoetterEnhet()` alltid har vært: svaret kan ikke
 * endre seg mens skjermen står (flagget er satt ved bygg, nettleseren er den samme), og
 * en ny avlesning per render ville gjort hva brukeren FÅR SE avhengig av tegnetidspunktet.
 */
export function useEnhet(): Enhetsstatus {
  const auth = useAuth();
  const { deviceFactor } = useKonfig();
  const [status] = useState<Enhetsstatus>(() => ({ tilbys: deviceFactor, mulig: deviceFactor && auth.stoetterEnhet() }));
  return status;
}
